import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LongueurStation } from 'src/app/domain/IBGN/longueur-station';

@Component({
  selector: 'app-ibgn-measure-box',
  templateUrl: './ibgn-measure-box.component.html',
  styleUrls: ['./ibgn-measure-box.component.scss']
})
export class IbgnMeasureBoxComponent implements OnInit {
  public DMAX = 20; // m
  newLongueur: LongueurStation;
  ValidDistanceMax = new UntypedFormControl(0, [Validators.max(this.DMAX)]);

  constructor(
    public dialogRef: MatDialogRef<IbgnMeasureBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data) {

    this.newLongueur = data;
  }

  ngOnInit(): void {
    this.ValidDistanceMax.markAsTouched();
  }

  CanAddNewMeasure() {
    return this.newLongueur;
  }

  CanSave() {
    return this.newLongueur && this.newLongueur.Longueur && this.newLongueur.Longueur > 0;
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm() {
    this.dialogRef.close(this.newLongueur);
  }
}
